<template>
	<div class='create-promise-wrap'>
		<div class='commitment-wrap'>
			<div class="nav-wrap">
				<div class="flex">
					<i class="iconfont icon-home1"></i>
					<router-link class="link" to="publicity/main">信用公示</router-link>
					<i class="el-icon-arrow-right"></i>
					<router-link class="link" to="/promise" replace><span>信用承诺</span></router-link>
				</div>
			</div>
		</div>
		<div class="form-wrap wrap-border">
			<el-form ref="promiseRef" label-position="top" :model="formData" size="mini">
				<el-form-item label="主体名称" prop="enterpriseClaimId" :rules="[{required: true, message: '请选择主体'}]">
					<el-select v-model="formData.enterpriseClaimId" placeholder="请从认领主体中选择" clearable>
						<el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="姓名" prop="realname" :rules="[{ required: true, message: '请填写' }]">
					<el-input v-model=" formData.realname" placeholder="填写法人、非法人组织、个体工商户名称或自然人姓名">
					</el-input>
				</el-form-item>

				<el-form-item label="承诺人类别" prop="type" :rules="[{required: true, message: '请选择承诺人类别'}]">
					<el-select v-model="formData.type" placeholder="请从认领主体中选择" clearable>
						<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="承诺人代码" prop="number" :rules="[{ required: true, message: '请填写' }]">
					<el-input v-model=" formData.number" placeholder="填写统一社会信用代码或填写身份号码">
					</el-input>
				</el-form-item>

				<el-form-item label="承诺类型" prop="category" :rules="[{required: true, message: '请选择承诺类型'}]">
					<el-select v-model="formData.category" placeholder="请选择承诺类型" clearable @change="categoryChange">
						<el-option v-for="item in categoryList" :key="item.id" :label="item.fullName" :value="item.enCode">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="其他承诺类型" prop="otherCategory" :rules="[{required: true, message: '其他承诺类型'}]" v-if="formData.category==='其他'">
					<el-input v-model="formData.otherCategory" placeholder="其他承诺类型"></el-input>
				</el-form-item>

				<el-form-item label="承诺事由" prop="reason" :rules="[{ required: true, message: '请输入承诺事由'}]">
					<el-input type="textarea" maxlength="1000" show-word-limit :row="10" v-model="formData.reason" placeholder="请输入承诺事由"></el-input>
				</el-form-item>

				<el-form-item label="承诺事项" prop="matter" :rules="[{required: formData.category !== '其他', message: '请选择承诺事项'}]">
					<el-select v-model="formData.matter" placeholder="请选择承诺事项" clearable>
						<el-option v-for="item in matterList" :key="item.id" :label="item.title" :value="item.title">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="承诺内容" prop="content" :rules="[{ required: true, message: '请填写承诺内容', trigger: 'blur' }]">
					<el-input type="textarea" maxlength="1000" show-word-limit :row="10" v-model="formData.content" placeholder="填写信用承诺书中承诺的主要内容"></el-input>
				</el-form-item>

				<el-form-item label="违诺责任" prop="breachpromise" :rules="[{ required: true, message: '请填写违诺责任', trigger: 'blur' }]">
					<el-input type="textarea" maxlength="1000" show-word-limit :row="10" v-model="formData.breachpromise" placeholder="填写信用承诺书中载明的不履行信用承诺要承担的主要责任"></el-input>
				</el-form-item>

				<el-form-item label="承诺作出日期" prop="jointime" :rules="[{required: true, message: '请选择承诺作出日期'}]">
					<el-date-picker value-format="yyyy-MM-dd" v-model="formData.jointime" align="right" type="date" placeholder="选择承诺作出日期" :picker-options="pickerOptions">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="承诺有效期" prop="validtime" :rules="[{required: true, message: '请选择承诺有效期'}]">
					<el-date-picker value-format="yyyy-MM-dd" v-model="formData.validtime" align="right" type="date" placeholder="选择承诺有效期" :picker-options="pickerOptions">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="承诺受理单位" prop="promiseacceptunit" :rules="[{ required: true, message: '请填写' }]">
					<el-input v-model="formData.promiseacceptunit" placeholder="填写信用承诺书受理单位名称"></el-input>
				</el-form-item>

				<el-form-item label="承诺受理单位统一社会信用代码" prop="promiseacceptunitcode" :rules="[{ required: true, message: '请填写' }]">
					<el-input v-model="formData.promiseacceptunitcode" placeholder="填写信用承诺书受理单位的统一社会信用代码"></el-input>
				</el-form-item>

				<el-form-item label="承诺书文件" prop="matterfile">
					<el-upload class="upload-demo" :limit="1" accept=".pdf,.jpg" :action="action" :on-preview="handlePreview" :before-upload="beforeUpload" :on-success="onSuccess"
						:on-error="onError" :on-remove="handleRemove" :file-list="fileList" list-type="picture">
						<el-button size="mini" type="primary">上传附件</el-button>
						<div slot="tip" class="el-upload__tip">支持jpg、pdf格式</div>
					</el-upload>
				</el-form-item>

				<el-form-item label="公开类型" prop="publicity" :rules="[{required: true, message: '请选择公开类型'}]">
					<el-radio-group v-model="formData.publicity">
						<el-radio label="可向社会公开"></el-radio>
						<el-radio label="特定范围内公开"></el-radio>
						<el-radio label="不可公开"></el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="备注" prop="description" :rules="[{ required: true, message: '请填写其他需要补充说明的信息' }]">
					<el-input type="textarea" maxlength="1000" show-word-limit :row="10" v-model="formData.description" placeholder="填写其他需要补充说明的信息"></el-input>
				</el-form-item>

				<el-form-item prop="placecode" label="地方编码" :rules="[{ required: true, message: '请填写6位行政区划码'}]">
					<el-input v-model="formData.placecode" placeholder="填写6位行政区划码"></el-input>
				</el-form-item>

				<el-form-item label="地方区划" prop="placename" :rules="[ { required: true, message: '请填写地方区划' }]">
					<el-input v-model="formData.placename" placeholder="填写地方区划"></el-input>
				</el-form-item>

				<el-form-item label="">
					<el-button type="primary" class="red-button" @click="submitHandler">提交</el-button>
					<el-button type="warning" @click="resetHandler">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { creditMemberEnterpriseClaims, getCode, getPromiseMatters, createPromise } from '@/api';
import BASE_URL from '@/api/base.js'

const typeList = Object.freeze([
	{
		name: '法人',
		id: 1
	},
	{
		name: '非法人组织',
		id: 2
	},
	{
		name: '个体工商户',
		id: 3
	},
	{
		name: '自然人',
		id: 4
	}
])

export default {
	components: {},
	data() {
		return {
			action: BASE_URL + '/api/file/upload',
			formData: {},
			companyList: [],
			categoryList: [],
			matterList: [],  //承诺事项
			typeList,
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now();
				},
			},
			fileList: []
		}
	},
	created() { },
	mounted() {
		this.getCompanyList();
		this.getCategoryList();
		this.getMatterList();
	},
	methods: {
		getCompanyList() {
			creditMemberEnterpriseClaims().then(res => {
				this.$set(this, 'companyList', res || []);
			})
		},
		getCategoryList() {
			getCode({ code: 'promiseMatter' }).then(res => {
                this.$set(this, 'categoryList', res||[])
			})
		},
		getMatterList() {
			const { category } = this.formData;
			if (category !== '其他') {
				const cateGoryId = (this.categoryList.find(item => item.fullName === category) || {}).enCode;
				if (cateGoryId) {
					getPromiseMatters({ category: cateGoryId }).then(res => {
						this.$set(this, 'matterList', res || []);
					})
				}
			}
		},
		categoryChange(e) {
			this.getMatterList()
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
			if (fileList.length > 0) {
				this.$set(this.formData, 'matterfile', undefined);
			}
		},
		handlePreview(file) {
			console.log(file);
		},
		beforeUpload(file) {
			const { type } = file;
			// if (!type.includes('pdf') || !type.includes('jpg') || !type.includes('jpeg')) {
			if (!['application/pdf', 'image/jpeg'].includes(type)) {
				this.$message({
					message: '只能上传jpg和pdf格式文件',
					type: 'warning'
				});
				return false;
			}
			return true;
		},
		onSuccess(response, file, fileList) {
			const { name } = file;
			const { result } = response;
			this.$set(this.formData, 'matterfile', result);
		},
		onError() { },
		resetHandler() {
			this.$refs['promiseRef'].resetFields();
			this.formData = {};
			this.fileList = [];
		},
		submitHandler() {

			this.$refs['promiseRef'].validate((valid) => {
				if (valid) {
					const { category } = this.formData;
					const params = Object.assign({}, this.formData, {
						category: category === '其他' ? ('其他-' + this.formData.otherCategory) : category
					});
					createPromise(params).then(res => {
						this.$message({
							message: '申请成功，请耐心等待审核',
							type: 'success'
						});
						this.resetHandler();
					})
				}
			})
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' >
	.commitment-wrap {
		.commitment-bottom {
			width: 1280px;
			margin: 0 auto;
			padding: 20px 0;
			& > .commitment-tab {
				border-bottom: 5px solid #dfe8ef;
				& > div {
					height: 50px;
					text-align: center;
					font-size: 18px;
					color: #212121;
					line-height: 50px;
					border-bottom: 5px solid transparent;
					padding: 0 15px;
					cursor: pointer;
					margin-bottom: -5px;
					&.active {
						color: $red;
						border-color: $red;
					}
				}
			}
		}
	}

	.create-promise-wrap {
		& > .form-wrap {
			width: 860px;
			margin: 20px auto;
			padding: 20px 0;
			& > .el-form {
				width: 600px;
				margin: 0 auto;
				.el-form-item__label {
					width: 100%;
				}
				.el-select,
				.el-input,
				.el-textarea {
					width: 100%;
				}
				.el-input {
					.el-input__inner {
						// font-size: 14px;
						// height: 40px;
						border-radius: 3px;
						border-color: #efefef;
					}
				}
				.el-textarea {
					min-height: 150px;
					.el-textarea__inner {
						min-height: 150px !important;
						border-radius: 3px;
						border-color: #efefef;
					}
				}
				.el-button {
					width: 120px;
					margin: 0 20px;
					&.red-button {
						background-color: $red;
						border-color: $red;
					}
				}
			}
		}
	}
</style>
